import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  logs: [],
  loading: false,
  error: null
};

const slice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    getCloudwatchLogsSuccess(state, action) {
      state.loading = false;
      state.logs = action.payload;
    },
    hasError(state, action) {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export function getCloudwatchLogs({ keyword, startTime, endTime }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    // Default to the past hour if no time range is provided
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    startTime = startTime ?? now - 3600; // Default to one hour ago
    endTime = endTime ?? now; // Default to now

    try {
      const queryString = `
        query GetCloudwatchLogs($keyword: String, $startTime: Int, $endTime: Int) {
          getCloudwatchLogs(keyword: $keyword, startTime: $startTime, endTime: $endTime) {
            timestamp
            message
            logStream
            log
          }
        }
      `;

      const variables = { keyword, startTime, endTime };

      const response = await axios.post('/graphql', {
        query: queryString,
        variables
      });

      const processedLogs = response.data.data.getCloudwatchLogs.map((log) => {
        const regex =
          /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)\s([a-f0-9-]{36})/;
        const match = log.message.match(regex);

        return {
          ...log,
          traceId: match ? match[2] : null, // Extract the trace ID
          message: log.message.replace(regex, '').trim() // Remove both datetime and trace ID
        };
      });

      dispatch(slice.actions.getCloudwatchLogsSuccess(processedLogs));
    } catch (error) {
      dispatch(
        slice.actions.hasError(error.response?.data?.errors || error.message)
      );
    }
  };
}

export default slice.reducer;
